

import React, { memo } from 'react';

import { EditorState } from 'draft-js';
import RequestProvider from '../../RequestProvider';
import { getUsersByName } from '../api';
import RichTextEditor from '../components/RichTextEditor';





















function RichTextEditorRoot({
  children,
  placeholder,
  label,
  editorState,
  onUpdateContent,
  inputType,
  onSave,
  disabled,
  hideControls,
  onCancel,
  organisationId,
  onBlur,
  onFocus,
  setFocusOnMount
})
{
  return (
    <RequestProvider
      requests={{
        getUsersByName: getUsersByName()
      }}>

      {(requests) =>
      <RichTextEditor
        {...requests}
        onUpdateContent={onUpdateContent}
        placeholder={placeholder}
        label={label}
        editorState={editorState}
        inputType={inputType}
        onSave={onSave}
        disabled={disabled}
        onCancel={onCancel}
        organisationId={organisationId}
        hideControls={hideControls}
        onBlur={onBlur}
        onFocus={onFocus}
        setFocusOnMount={setFocusOnMount}>

          {children}
        </RichTextEditor>}

    </RequestProvider>);

}

export default memo(RichTextEditorRoot);